import { useState } from "react";
import { Form, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { lowerCase } from "lodash";

import { ReactComponent as DeleteIcon } from "@/assets/images/desktop/closemin.svg";
import { decimalValidateNew, formatMiles, formatMilesDecimalNew, integerValidate } from "@/services/Utils";
import { NoOptionsMessage, SingleValue } from "@/components/ReactSelect/NoOptions";
import ProductInput from "@/components/Form/Inputs/Product/ProductInput";

import UnitLoadItemSuggestions from "./UnitLoadItemSuggestions";

import classes from "../loadinventory.module.scss";

const UnitLoadTableItem = ({ data, setData, products, setProducts, productsGenerics, setProductsGenerics, units_measurement }) => {
	const [productText, setProductText] = useState("");

	const handleValueChange = (idx, key, value) => {
		let newData = [...data.items];
		newData[idx][key] = value;

		const numbersKeys = ["container_quantity", "container_content", "total_price"];
		if (numbersKeys.includes(key) && value !== "" && value !== null) {
			newData[idx][key] = value.replace(/\./g, "");
		}

		if (key === "product_id") {
			const product = products.find((p) => p.value === value);
			if (product && product.unit_measurement === "cc") {
				newData[idx].unit_measurement = 5;
			}
			if (product && product.unit_measurement === "g") {
				newData[idx].unit_measurement = 2;
			}
			if (product && product.unit_measurement === "u") {
				newData[idx].unit_measurement = 7;
			}
			if (!product) {
				newData[idx].unit_measurement = "";
			}
		}
		setData({ ...data, items: newData });
	};

	return (
		<Table className={classes.tableDetail}>
			<thead className={classes.tableDetailHead}>
				<tr>
					<th style={{ width: "2%", textAlign: "center" }}>#</th>
					<th>
						Producto <br />
						<small>Ingrese al menos 3 letras para buscar.</small>{" "}
					</th>
					<th>Cant. Envases</th>
					<th>Contenido por Envase</th>
					<th>U.M.</th>
					<th>Precio Neto</th>
					<th>F. Vencimiento</th>
					<th>Lote Producción</th>
					<th>Génerico</th>
					<th></th>
				</tr>
			</thead>
			<tbody className={classes.tableBody}>
				{data &&
					data.items &&
					data.items.map((item, i) => {
						return (
							<tr key={i}>
								{/* Line Number */}
								<td
									style={{
										width: "2%",
										textAlign: "center",
										verticalAlign: "middle",
										fontSize: "11px",
										color: "#6c757d",
										fontWeight: "500",
									}}
								>
									{i + 1}
								</td>
								{/* Product */}
								<td
									style={{
										width: "20%",
									}}
								>
									<div style={{ display: "flex" }}>
										<div style={{ width: item.product_suggestions && item.product_suggestions.length !== 0 ? "90%" : "100%" }}>
											<CreatableSelect
												value={item && products?.find((p) => String(p.value) === String(item.product_id))}
												placeholder={<span style={{ fontSize: "12px" }}>Seleccione</span>}
												isClearable
												options={
													productText.length > 1 ? products?.filter((p) => lowerCase(p.label).includes(lowerCase(productText))) : []
												}
												onInputChange={(value) => {
													setProductText(value);
												}}
												menuPortalTarget={document.body}
												menuPlacement="bottom"
												components={{ NoOptionsMessage, SingleValue, Option: ProductInput }}
												formatCreateLabel={(value) => {
													return `Crear ${value}`;
												}}
												onChange={(opt, meta) => {
													if (meta.action === "create-option") {
														setProducts([
															...products,
															{
																id: "",
																value: opt?.value,
																label: opt?.value,
																generic: 0,
																unit_measurement: "",
															},
														]);
													}
													handleValueChange(i, "product_id", opt?.value);
													setProductText("");
												}}
											/>
										</div>
										{item.product_suggestions && item.product_suggestions.length !== 0 && (
											<UnitLoadItemSuggestions suggestions={item.product_suggestions} index={i} data={data} setData={setData} />
										)}
									</div>
								</td>
								{/* Container Quantity */}
								<td
									style={{
										width: "9%",
									}}
								>
									<Form.Control
										style={{
											padding: "6px",
											textAlign: "right",
										}}
										type="text"
										value={item && item.container_quantity ? formatMiles(item.container_quantity) : ""}
										onChange={(e) => handleValueChange(i, "container_quantity", e.target.value)}
										onKeyDown={integerValidate}
									/>
								</td>
								{/* Container Content */}
								<td
									style={{
										width: "9%",
									}}
								>
									<Form.Control
										style={{
											padding: "6px",
											textAlign: "right",
										}}
										type="text"
										value={item && item.container_content ? formatMilesDecimalNew(item.container_content) : ""}
										onChange={(e) => handleValueChange(i, "container_content", e.target.value)}
										onKeyDown={decimalValidateNew}
									/>
								</td>
								{/* U.M. */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Select
										value={item && units_measurement?.find((u) => Number(u?.value) === Number(item.unit_measurement))}
										placeholder={""}
										isClearable
										options={
											item.product_id &&
											units_measurement.filter((u) => u.base_unit === products.find((p) => p.value === item.product_id)?.unit_measurement)
												.length > 0
												? units_measurement.filter(
														(u) => u.base_unit === products.find((p) => p.value === item.product_id)?.unit_measurement,
													)
												: units_measurement
										}
										onChange={(value) => handleValueChange(i, "unit_measurement", value?.value)}
										menuPortalTarget={document.body}
										menuPlacement="bottom"
										components={{ NoOptionsMessage }}
									/>
								</td>
								{/* Total Price */}
								<td
									style={{
										width: "9%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										style={{
											textAlign: "right",
										}}
										value={item && item.total_price ? formatMilesDecimalNew(item.total_price) : ""}
										onChange={(e) => handleValueChange(i, "total_price", e.target.value)}
										onKeyDown={decimalValidateNew}
									/>
								</td>
								{/* Expiration Date */}
								<td
									style={{
										width: "12%",
									}}
								>
									<Form.Control
										type={item && item.expiration_date ? "date" : "text"}
										onFocus={(e) => (e.target.type = "date")}
										onBlur={(e) => {
											if (!(item && item.expiration_date)) {
												e.target.type = "text";
											}
										}}
										value={item && item.expiration_date ? item.expiration_date : ""}
										onChange={(e) => handleValueChange(i, "expiration_date", e.target.value)}
									/>
								</td>
								{/* Lot Production */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Form.Control
										type="text"
										value={item && item.lot_production ? item.lot_production : ""}
										onChange={(e) => handleValueChange(i, "lot_production", e.target.value)}
									/>
								</td>
								{/* Generic */}
								<td
									style={{
										width: "18%",
									}}
								>
									<div style={{ display: "flex" }}>
										<div style={{ width: item.generic_suggestions && item.generic_suggestions.length !== 0 ? "90%" : "100%" }}>
											<CreatableSelect
												value={item && productsGenerics?.find((p) => String(p?.value) === String(item.generic))}
												placeholder={<span style={{ fontSize: "12px" }}>Seleccione</span>}
												isClearable
												options={productsGenerics?.filter((p) => p.estate_id === data.estate_id)}
												onInputChange={(value) => {
													setProductText(value);
												}}
												menuPortalTarget={document.body}
												menuPlacement="bottom"
												components={{ NoOptionsMessage }}
												formatCreateLabel={(value) => {
													return `Crear ${value}`;
												}}
												onChange={(opt, meta) => {
													if (meta.action === "create-option") {
														setProductsGenerics([
															...productsGenerics,
															{
																id: "",
																value: opt?.value,
																label: opt?.value,
																unit_measurement: "",
																estate_id: data.estate_id,
															},
														]);
													}
													handleValueChange(i, "generic", opt?.value);
													setProductText("");
												}}
											/>
											{item.generic_suggestions && item.generic_suggestions.length !== 0 && (
												<UnitLoadItemSuggestions
													suggestions={item.generic_suggestions}
													index={i}
													data={data}
													setData={setData}
													isGeneric={true}
												/>
											)}
										</div>
									</div>
								</td>
								{/* Actions */}
								{item && (
									<td
										style={{
											width: "5%",
											textAlign: "center",
										}}
									>
										<OverlayTrigger overlay={<Tooltip>Eliminar Producto</Tooltip>}>
											<DeleteIcon
												className={classes.buttonClose}
												onClick={() => {
													let newItems = [...data.items];
													newItems.splice(i, 1);
													setData({
														...data,
														items: newItems,
													});
												}}
											/>
										</OverlayTrigger>
									</td>
								)}
							</tr>
						);
					})}
			</tbody>
		</Table>
	);
};

export default UnitLoadTableItem;
